import React, { Component } from 'react';
import { Button, Modal, Image, Icon } from 'semantic-ui-react';
import _ from 'lodash';

class TrialExpiredModal extends Component {

  render() {
    const { open, username } = this.props;
    const centered = {
      textAlign: 'center',
    };
    const buttonStyle = { width: 300 };

    const firstName = _.split(username, ' ')[0];
    return (
      <div>

        <Modal
          open={open}
          closeOnEscape={false}
          closeOnRootNodeClick={false}
          onClose={this.close}
          size="tiny"
        >
          <Modal.Header>
            <Image
              src="/dyzio-logo-large.png"
              size="small"
              alt="dyzio"
              centered
            />
          </Modal.Header>
          <Modal.Content style={centered}>
            <h3>Hi { firstName }! Your free trial has expired <Icon name="frown" /></h3>
            <p>Use the green intercom button at the bottom right of your screen
             to contact our live support team or click <a href="mailto:sales@dyzio.co?subject=dyzio%20license">here</a> to send an email to our sales team</p>
          </Modal.Content>
          <Modal.Actions style={centered}>
            <Button
              centered
              icon="log out"
              style={buttonStyle}
              color="green"
              size="large"
              content="log out"
              onClick={() => { window.location = '/logout'; }}
            />
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

export default TrialExpiredModal;



/** WEBPACK FOOTER **
 ** ./src/components/trial-expired/index.js
 **/